import React from "react";
import useScrollToTop from "./../../../hooks/useScollToTop";

import useAssociationsAdmin from "./hooks/useAssociationsAdmin";

import AssociationsHero from "./components/AssociationsHero";
import AssociationsStatsGrid from "./components/AssociationsStatsGrid";
import AssociationsFiltersPanel from "./components/AssociationsFiltersPanel";
import AssociationsList from "./components/AssociationsList";
import AssociationsFormDrawer from "./components/AssociationsFormDrawer";
import AssociationsPreviewDrawer from "./components/AssociationsPreviewDrawer";
import AssociationsDeleteDrawer from "./components/AssociationsDeleteDrawer";

import AdminMediaPickerDrawer from "../_shared/ui/AdminMediaPickerDrawer";
import { ASSOCIATIONS_MEDIA_CATEGORY_DEFAULT } from "./data/associationsAdminData";

export default function AssociationsAdmin() {
  useScrollToTop();
  const associations = useAssociationsAdmin();

  return (
    <div className="mx-auto w-full max-w-[1600px] px-1 pb-10 sm:px-2 lg:px-0">
      <AssociationsHero
        stats={associations.stats}
        loading={associations.loading}
        onCreate={associations.openCreate}
      />

      {associations.notice ? (
        <div className="mt-5 rounded-[1.5rem] border border-emerald-200 bg-emerald-50 px-5 py-4 text-sm font-bold text-emerald-800 shadow-sm dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300">
          {associations.notice}
        </div>
      ) : null}

      {associations.error ? (
        <div className="mt-5 rounded-[1.5rem] border border-rose-200 bg-rose-50 px-5 py-4 text-sm font-bold text-rose-800 shadow-sm dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300">
          {associations.error}
        </div>
      ) : null}

      <AssociationsStatsGrid
        stats={associations.stats}
        loading={associations.loading}
      />

      <AssociationsFiltersPanel
        q={associations.q}
        categorie={associations.categorie}
        stateFilter={associations.stateFilter}
        hasLogo={associations.hasLogo}
        withGps={associations.withGps}
        limit={associations.limit}
        onChangeQ={associations.setQ}
        onChangeCategorie={associations.changeCategorie}
        onChangeStateFilter={associations.changeStateFilter}
        onChangeHasLogo={associations.changeHasLogo}
        onChangeWithGps={associations.changeWithGps}
        onChangeLimit={associations.changeLimit}
        onSubmit={associations.onSubmitSearch}
        onReset={associations.resetFilters}
        onRefresh={associations.fetchData}
        loading={associations.loading}
      />

      <AssociationsList
        items={associations.items}
        loading={associations.loading}
        total={associations.total}
        page={associations.page}
        totalPages={associations.totalPages}
        actionId={associations.actionId}
        onPageChange={associations.setPage}
        onPreview={associations.openPreview}
        onEdit={associations.openEdit}
        onToggle={associations.onToggle}
        onAskDelete={associations.openDelete}
      />

      <AssociationsFormDrawer
        open={associations.formOpen}
        form={associations.form}
        fieldErrors={associations.fieldErrors}
        saving={associations.saving}
        isEdit={!!associations.currentId}
        onClose={associations.closeForm}
        onChange={associations.updateFormField}
        onSave={associations.onSave}
        onOpenMediaPicker={associations.openMediaPicker}
      />

      <AssociationsPreviewDrawer
        open={!!associations.previewItem}
        item={associations.previewItem}
        onClose={associations.closePreview}
        onEditFromPreview={associations.openEditFromPreview}
      />

      <AssociationsDeleteDrawer
        open={!!associations.deleteItem}
        item={associations.deleteItem}
        deleting={associations.deleting}
        onClose={associations.closeDelete}
        onConfirm={associations.onDelete}
      />

      <AdminMediaPickerDrawer
        open={associations.mediaPickerOpen}
        onClose={associations.closeMediaPicker}
        onSelect={associations.handleSelectMedia}
        title="Choisir un logo"
        subtitle="Sélectionnez une image ou un logo pour représenter l’association."
        defaultCategory={ASSOCIATIONS_MEDIA_CATEGORY_DEFAULT}
      />
    </div>
  );
}